import styled, { css } from 'styled-components';
import { NavLink } from 'react-router-dom';
import RightArrow from '../../Icons/RightArrow';
import SmallFilledAccount from '../../Icons/SmallFilledAccount';
import NotificationBell from '../../Icons/NotificationBell';
import PersonalDetails from '../../Icons/PersonalDetails';
import FinancingTerms from '../../Icons/FinancingTerms';
import ReferralsNavIcon from '../../Icons/ReferralsNavIcon';
import PrivacySettingsIcon from '../../Icons/PrivacySettingsIcon';

export const Navigation = styled.nav`
  width: 100%;
  margin-bottom: 180px;
`;

export const AccountContainer = styled.div`
  height: 94px;
  padding: 0 26px;
  display: flex;
  background-color: ${(props: any) => props.theme.carvana.blue.dark};
`;

export const AccountIcon = styled(SmallFilledAccount)`
  align-self: center;
  width: 25px;
`;

export const AccountHeader = styled.p`
  flex: 1;
  padding-left: 16px;
  font-size: 20px;
  align-self: center;
  display: inline-block;
  color: ${(props: any) => props.theme.carvana.white.primary};
`;

export const NavTabContainer = styled.ul`
  margin: 0;
  padding: 0;
`;

export const NavigationItemLink = styled(NavLink)`
  :hover {
    background-color: ${(props: any) => props.theme.carvana.gray.background};
    svg {
      fill: ${(props: any) => props.theme.carvana.blue.hover};
    }
    p {
      color: ${(props: any) => props.theme.carvana.blue.hover};
    }
  }
`;

export const NavigationItemContainer = styled.li`
  display: flex;
  height: 90px;
  padding: 0 22px 0 26px;
  background-color: ${(props: any) => props.theme.carvana.white.primary};
  border-bottom: 1px solid ${(props: any) => props.theme.carvana.gray.light};
`;

const MobileNavigationIcons = css`
  width: 25px;
  align-self: center;
  fill: ${(props: any) => props.theme.carvana.blue.dark};
`;

export const PersonalDetailsIcon = styled(PersonalDetails)`
  ${MobileNavigationIcons};
`;

export const FinancingTermsIcon = styled(FinancingTerms)`
  ${MobileNavigationIcons};
`;

export const NotificationBellIcon = styled(NotificationBell)`
  ${MobileNavigationIcons};
`;

export const ReferralsIcon = styled(ReferralsNavIcon)`
  ${MobileNavigationIcons};
`;

export const PrivacySettings = styled(PrivacySettingsIcon)`
  ${MobileNavigationIcons};
`;

export const NavigationLabel = styled.p`
  font-weight: 700;
  text-transform: uppercase;
  line-height: 24px;
  color: ${(props: any) => props.theme.carvana.blue.dark};
`;

export const NavigationDescription = styled.p`
  font-weight: 400;
  color: ${(props: any) => props.theme.carvana.gray.medium};
`;

export const NavigationLabelContainer = styled.div`
  flex: 1;
  font-size: 14px;
  line-height: 14px;
  align-self: center;
  padding: 0 0 6px 16px;
`;

export const RightArrowIcon = styled(RightArrow)`
  width: 25px;
  align-self: center;
  fill: ${(props: any) => props.theme.carvana.gray.medium};
`;
